export default {
    membres: [],
    total: 0
}